export default class ChatHistory {
    constructor() {
        this.threadID = null
        this.messages = []
    }
}
